var map = {
	"./clock.svg": 861,
	"./frame.svg": 865,
	"./palette.svg": 866,
	"./phone.svg": 867,
	"./shirt.svg": 869
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;



//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes ^\.\/.*\.svg$
// module id = 694
// module chunks = 1